// SOMMET ZÜRICH - Photo collection (product-shot photos)
export const PHOTO_COLLECTION = [
  {
    id: "sommet-noctyra-weiss",
    defaultStrap: "leather",
    name: "Noctyra",
    tagline: { de: "Weiß", en: "White" },
    price: 229,
    image: "/watches/noctyra-weiss.png",
    description: {
      de: "Weißes Zifferblatt mit geriffelter Edelstahl-Lünette, SOMMET-Signatur, Datumsanzeige und schwarzem Kautschukband.",
      en: "White dial with fluted stainless steel bezel, SOMMET signature, date window and black rubber strap.",
    },
  },
  {
    id: "sommet-noctyra-gruen",
    defaultStrap: "leather",
    name: "Noctyra",
    tagline: { de: "Grün", en: "Green" },
    price: 229,
    image: "/watches/noctyra-gruen.png",
    description: {
      de: "Tiefgrünes Sunburst-Zifferblatt mit geriffelter Edelstahl-Lünette, Datumsanzeige und schwarzem Kautschukband.",
      en: "Deep green sunburst dial with fluted stainless steel bezel, date window and black rubber strap.",
    },
  },
  {
    id: "sommet-noctyra-hellblau",
    defaultStrap: "leather",
    name: "Noctyra",
    tagline: { de: "Hellblau", en: "Light Blue" },
    price: 229,
    image: "/watches/noctyra-hellblau.png",
    description: {
      de: "Hellblaues Sunburst-Zifferblatt mit römischen Indizes, geriffelter Edelstahl-Lünette, Datumsanzeige und schwarzem Kautschukband.",
      en: "Light blue sunburst dial with Roman indices, fluted stainless steel bezel, date window and black rubber strap.",
    },
  },
  {
    id: "sommet-noctyra-grau",
    defaultStrap: "leather",
    name: "Noctyra",
    tagline: { de: "Grau", en: "Grey" },
    price: 229,
    image: "/watches/noctyra-grau.png",
    description: {
      de: "Silbergraues Sunburst-Zifferblatt mit geriffelter Edelstahl-Lünette, Datumsanzeige und schwarzem Kautschukband.",
      en: "Silver-grey sunburst dial with fluted stainless steel bezel, date window and black rubber strap.",
    },
  },
  {
    id: "sommet-naotic-gold-schwarz",
    defaultStrap: "leather",
    name: "Naotic",
    tagline: { de: "Gold / Schwarz", en: "Gold / Black" },
    price: 229,
    image: "/watches/naotic-gold-schwarz.png",
    description: {
      de: "Roségold-Gehäuse mit schwarzer Keramik-Lünette, schwarzem Zifferblatt mit römischen Indizes, Datumsanzeige und schwarzem Kautschukband.",
      en: "Rose gold case with black ceramic bezel, black dial with Roman indices, date window and black rubber strap.",
    },
  },
  {
    id: "sommet-azur-chrono",
    defaultStrap: "steel",
    name: "Tempus",
    tagline: { de: "Weiß", en: "White" },
    price: 269,
    image: "/watches/tempus-weiss.png",
    description: {
      de: "Chronograph mit reinweißem Zifferblatt, drei Sub-Registern, Tachymeter-Skala und Edelstahl-Armband.",
      en: "Chronograph with pure white dial, three sub-registers, tachymeter scale and steel bracelet.",
    },
  },
  {
    id: "sommet-ocean-chrono",
    defaultStrap: "steel",
    name: "Tempus",
    tagline: { de: "Schwarz", en: "Black" },
    price: 269,
    image: "/watches/schwarz-tempus.png",
    description: {
      de: "Chronograph mit schwarzem Zifferblatt, silbernen Sub-Registern, Tachymeter-Skala und Milanaise-Mesh in Edelstahl.",
      en: "Chronograph with black dial, silver sub-registers, tachymeter scale and stainless milanese mesh.",
    },
  },
  {
    id: "sommet-argent-elegance",
    defaultStrap: "steel",
    name: "Präzissionsmaster",
    tagline: { de: "Blau", en: "Blue" },
    price: 269,
    image: "/watches/praez-a.png",
    description: {
      de: "Silbergehäuse mit tiefblauem Zifferblatt, Datumsanzeige und Milanaise-Mesh in Edelstahl.",
      en: "Silver case with deep blue dial, date window and stainless milanese mesh.",
    },
  },
  {
    id: "sommet-panda-mesh",
    defaultStrap: "leather",
    name: "Präzissionsmaster",
    tagline: { de: "Weiß / Rot", en: "White / Red" },
    price: 269,
    image: "/watches/praez-b.png",
    description: {
      de: "Silbergehäuse mit weißem Zifferblatt, rotem Sekunden-Ring, Datumsanzeige und weißem Kautschukband.",
      en: "Silver case with white dial, red seconds ring, date window and white rubber strap.",
    },
  },
  {
    id: "sommet-carre-verde-braun",
    defaultStrap: "leather",
    name: "4eck",
    tagline: { de: "Grün / Braun", en: "Green / Brown" },
    price: 229,
    image: "/watches/carre-verde-braun.png",
    description: {
      de: "Quadratisches Edelstahl-Gehäuse mit smaragdgrünem Zifferblatt, römischen Indizes und braunem Alligator-Lederband.",
      en: "Square stainless steel case with emerald dial, Roman indices and brown alligator leather strap.",
    },
  },
  {
    id: "sommet-carre-verde-schwarz",
    defaultStrap: "leather",
    name: "4eck",
    tagline: { de: "Grün / Schwarz", en: "Green / Black" },
    price: 229,
    image: "/watches/carre-verde-schwarz.png",
    description: {
      de: "Quadratisches Edelstahl-Gehäuse mit smaragdgrünem Zifferblatt, römischen Indizes und schwarzem Alligator-Lederband.",
      en: "Square stainless steel case with emerald dial, Roman indices and black alligator leather strap.",
    },
  },
];
